import Product from "./Product";
import SelectOption from "./SelectOption";

export interface ChassisType extends Product {
    dealerIdCustomPricing?: string,
    model: ChassisModelTypes,
    year: number,
    badge: string,
    series: ChassisSeriesTypes,
    retailPrice: number,
    marketingSlogan?: string,
    passengerCapacity: ChassisPassengerCapacities,
    preassembled: boolean,
    bodyColorOptions: Product[],
    liftKitOptions?: Product[],
    chassisBatteryConfigOptions: Product[],
    chassisBatteryOptions: Product[],
    wheelSizeOptions: SelectOption[],
    wheelOptions: Product[],
    wheelOptionsLifted: Product[],
    tireOptions: Product[],
    tireOptionsLifted: Product[],
    lugNutOptions?: Product[],
    topOptions: Product[],
    windshieldOptions: Product[],
    frontSeatOptions: Product[],
    middleSeatOptions?: Product[],
    rearSeatOptions?: Product[],
    seatFrameOptions?: Product[],
    lsvKitOptions?: Product[],
    allowInternationalPurchase: boolean,
    includedAccessories?: Product[],
    includedAccessoriesLifted?: Product[],
    optionalAccessories?: Product[]
    optionalAccessoriesLifted?: Product[]
}

export enum ChassisPassengerCapacities {
    "2 Passenger" = 2,
    "4 Passenger" = 4,
    "6 Passenger" = 6
}

export enum ChassisSeriesTypes {
    "XSeries" = "XSeries",
    "ESeries" = "ESeries",
    "Ascent" = "Ascent"
}

export enum ChassisModelTypesInternational {
    X2 = 'X2',
    X4 = 'X4',
    X6 = 'X6',
    E4 = 'E4',
    E2 = 'E2',
    E2Shuttle = 'E2-Shuttle',
    E6Shuttle = 'E6-Shuttle',
    A4 = 'A4'
}

export enum ChassisModelTypesDomestic {
    X4 = 'X4',
    X6 = 'X6',
    E4 = 'E4',
    A4 = 'A4'
}

export enum ChassisModelTypes {
    X2 = 'X2',
    X4 = 'X4',
    X6 = 'X6',
    E4 = 'E4',
    E2 = 'E2',
    E2Shuttle = 'E2-Shuttle',
    E6Shuttle = 'E6-Shuttle',
    A4 = 'A4'
}

export type ChassisModelTypeValues = `${ChassisModelTypes}`;
